<template>
    <div class="access-body" :class="{ active: showbg === true }">
        <div class="access-container" @click="$emit('showDetail'), showbg = !showbg">
            <div class="access-left">
                <div class="access-header">
                    <div class="access-title">{{accessInfo.deviceName || '--'}}</div>
                    <img class="access-doorPic" src="@/assets/img/关门.png" alt="">
                </div>
                <div class="access-content">
                    <img class="access-pic"
                        :src="accessInfo.FacePic?('data:image/png;base64,' + accessInfo.FacePic):require('@/assets/img/userDefault.png')"
                        alt="">
                    <div class="access-dataContainer">
                        <div class="access-name">{{accessInfo.Name || '--'}}</div>
                        <div class="access-time">
                            {{(DateDiff(new Date(accessInfo.EnterDate).getTime())) ? (DateDiff(new Date(accessInfo.EnterDate).getTime()) + ' 进入') : '--'}}
                        </div>
                    </div>
                </div>
            </div>
            <img class="access-right" src="@/assets/img/right_unselected.png" alt="">
        </div>
    </div>
</template>

<script>
    import DateDiff from '../../../util/DateDiff'
    export default {
        name: "Access",
        props: ["accessInfo", "width", "height", "title"],
        data() {
            return {
                showbg: false
            }
        },
        methods: {
            DateDiff(value) {
                return DateDiff(value)
            },
        }
    }
</script>

<style lang="less" scoped>
    .active {
        background: rgba(0, 43, 102, 0.04);
    }

    .access-body {
        .w(528);
        .h(158);
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .access-container {
            width: 91%;
            height: 80%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .access-left {
                width: 90%;
                height: 90%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;

                .access-header {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;

                    .access-title {
                        font-size: 18rem;
                        color: #333333;
                    }

                    .access-doorPic {
                        margin-left: 180/192vw;
                    }
                }

                .access-content {
                    .h(72);
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;

                    .access-pic {
                        .w(72);
                        .h(72);
                    }

                    .access-dataContainer {
                        .h(72);
                        margin-left: 230/192vw;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        align-items: flex-start;
                        font-size: 18rem;
                        color: #333333;

                        .access-time {
                            font-size: 14rem;
                            color: #999999;
                        }

                    }
                }
            }
        }
    }
</style>